(function () {
    const screens = {
        main:          document.querySelector('#js-streak-main'),
        'how-to-play': document.querySelector('#js-streak-how-to-play'),
        challenges:    document.querySelector('#js-streak-challenges'),
        'my-streak':   document.querySelector('#js-streak-my-streak'),
    };

    if (!screens.main) return;

    function showScreen(name) {
        Object.entries(screens).forEach(([key, el]) => {
            if (el) el.hidden = key !== name;
        });
    }

    document.querySelector('#js-streak-btn-how-to-play')
        ?.addEventListener('click', (e) => { e.preventDefault(); showScreen('how-to-play'); });

    document.querySelector('#js-streak-btn-challenges')
        ?.addEventListener('click', (e) => { e.preventDefault(); showScreen('challenges'); });

    document.querySelector('#js-streak-btn-my-streak')
        ?.addEventListener('click', (e) => {
            e.preventDefault();
            showScreen('my-streak');
        });

    document.querySelectorAll('.js-streak-info-back')
        .forEach(btn => btn.addEventListener('click', () => showScreen('main')));

    const expandBtn   = document.querySelector('#js-streak-expand');
    const calendar    = document.querySelector('#js-streak-calendar');
    const expandLabel = document.querySelector('#js-streak-expand-label');

    if (expandBtn && calendar && expandLabel) {
        expandBtn.addEventListener('click', () => {
            const opening = calendar.hidden;
            calendar.hidden = !opening;
            expandBtn.classList.toggle('is-open', opening);
            expandLabel.textContent = opening ? 'Zwiń' : 'Wszystkie dni';
        });
    }
})();
